import type { Brand } from "@src/domain/entities/brand/Brand";
import type { UpdateBrandDTO } from "@src/domain/dto/brands/UpdateBrand.dto";
import type { IBrandRepository } from "@src/domain/repositories/brand";

export class UpdateBrandUseCase {
  private readonly brandRepository: IBrandRepository;

  constructor(brandRepository: IBrandRepository) {
    this.brandRepository = brandRepository;
  }

  async execute(params: UpdateBrandDTO): Promise<Brand> {
    return this.brandRepository.updateBrand(params);
  }
}
